
import React from 'react';
import { Expense } from '@/types/expense';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { useExpenseActions } from '../hooks/useExpenseActions';
import { useAuth } from '@/contexts/auth';

interface ExpenseTableRowProps {
  expense: Expense;
  currentUserId?: string;
  showActions: boolean;
  formatCurrency: (amount: number, currency: string) => string;
  formatDate: (dateString: string) => string;
}

const ExpenseTableRow: React.FC<ExpenseTableRowProps> = ({ 
  expense, 
  currentUserId, 
  showActions,
  formatCurrency,
  formatDate
}) => {
  const { user } = useAuth();
  const { handleDelete } = useExpenseActions();

  return (
    <tr className="hover:bg-gray-50 transition-colors">
      <td className="px-4 py-3">{expense.description}</td>
      <td className="px-4 py-3 font-medium">
        {formatCurrency(expense.amount, expense.currency)}
      </td>
      <td className="px-4 py-3 capitalize">
        {expense.split_type}
      </td>
      <td className="px-4 py-3">
        {expense.paid_by === currentUserId ? 'You' : 'Other'}
      </td>
      <td className="px-4 py-3 text-gray-500 text-sm">
        {formatDate(expense.created_at)}
      </td>
      {showActions && (
        <td className="px-4 py-3">
          {expense.paid_by === user?.id && (
            <Button
              variant="destructive"
              size="sm"
              onClick={() => handleDelete(expense.id)}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </td>
      )}
    </tr>
  );
};

export default ExpenseTableRow;
